module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/powered-by-qualia.svg";